import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import CompanyMarketProductsPage, {
  MarketConfiguration,
} from './CompanyMarketProducts';

const productsConfiguration: MarketConfiguration = {
  marketId: 1,
  breadcrumbRoute: 'company-profile-products',
  titleMessageKey: 'company-profile-products.title',
  productRoute: 'company-profile-product',
};

const companyProductsPagePropertyTypes = {
  slug: PropTypes.string.isRequired,
};

type CompanyProductsPageProperties = InferProps<
  typeof companyProductsPagePropertyTypes
>;

const CompanyProductsPage = ({ slug }: CompanyProductsPageProperties) => (
  <CompanyMarketProductsPage
    slug={slug}
    configuration={productsConfiguration}
  />
);

CompanyProductsPage.propTypes = companyProductsPagePropertyTypes;

export { CompanyMarketProducts as CompanyProducts } from './CompanyMarketProducts';
export default CompanyProductsPage;
